export const MODULE_NAME = 'billing-and-payments';
export const BILLING_AND_PAYMENTS_ROUTE = `/${MODULE_NAME}`;
